import { makeStyles } from "@material-ui/core";
import { COLORS } from "config/theme/baseTheme";

export const useStyles = makeStyles((theme) => ({
    container: {
      backgroundColor: "#DBEAFE",
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      cursor: "pointer",
      borderLeft: `4px solid ${COLORS.PRIMARY_MAIN}`, 
    },
    deliveryDetails: {
      display: "flex",
      alignItems: "center",
    },
    label: {
      marginRight: theme.spacing(1),
      fontSize: 14,
      fontWeight: 400
    },
    consignmentText: {
      fontWeight: 600,
      marginRight: theme.spacing(0.5),
      color: COLORS.PRIMARY_MAIN,
      fontSize: 14,
    },
    consignmentItem: {
      cursor: "pointer",
      marginRight: theme.spacing(0.5),
      display: "inline-flex",
      alignItems: "center",
      fontSize: 14,
    },
    icon: {
      marginLeft: theme.spacing(0.5),
    },
  }));